import { FormGroup, FormControl } from '@angular/forms';
import { ContentService } from 'app/store/services/content.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';

@Component({
  selector: 'app-edit-user-replay',
  templateUrl: './edit-user-replay.component.html',
  styleUrls: ['./edit-user-replay.component.scss'],
})
export class EditUserReplayComponent implements OnInit {
  formGroup: FormGroup;

  replayType: string;
  replayContent: string;

  cancelButtonProperties: Button = {
    text: 'Cancel',
    color: ButtonColor.BLUE,
    route: ['/contents/user_replies'],
    size: ButtonSize.SMALL,
  };

  submitButtonProperties: Button = {
    color: ButtonColor.ORANGE,
    text: 'Save',
    size: ButtonSize.SMALL,
    onClick: () => {
      if (this.formGroup.valid) {
        this.contentService
          .updateUserReplay(
            this.replayType,
            this.formGroup.get('content').value
          )
          .subscribe(result => {
            if (result && result.reply_id) {
              this.router.navigate(['/contents/user_replies']);
            }
          });
      }
    },
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private contentService: ContentService,
    private router: Router
  ) {}

  ngOnInit() {
    this.replayType = this.activatedRoute.snapshot.params.type;

    this.contentService.getUserReplay(this.replayType).subscribe(result => {
      this.formGroup = new FormGroup({
        content: new FormControl(result.reply_content),
      });

      this.replayContent = result.reply_content;
    });
  }

  getReplayContentName() {
    switch (this.replayType) {
      case 'followup':
        return 'Follow Up Immediate Email';
      case 'followup-future':
        return 'Follow Up Future Email';
      case 'followup-cycle':
        return 'Follow Up Cycle Email';
      case 'cycle':
        return 'Cycle Immediate Email';
      case 'cycle-future':
        return 'Cycle Future Email';
      case 'vip-message':
        return 'Vip Left Message';
      default:
        return (
          this.replayType.charAt(0).toUpperCase() + this.replayType.substr(1)
        );
    }
  }
}
